import { useQuery } from '@tanstack/react-query';
import { TechnicianService } from '@/services/technicianService';
import { queryKeys } from '@/hooks/queries/queryKeys';

export function useTechniciansQuery(enabled: boolean) {
    return useQuery({
        queryKey: queryKeys.technicians,
        queryFn: () => TechnicianService.getTechnicians(),
        enabled,
    });
}
